var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[_c('hr',{staticClass:"divider--line"}),_vm._v(" "),_c('p',{staticClass:"flex flex-vertical-center divider--text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }